import { atom } from 'recoil';

//
export const searchTerm = atom<string>({
  key: 'searchTerm',
  default: '',
});

//키워드검색여부
export const keywordSearchYn = atom<boolean>({
  key: 'keywordSearchYn',
  default: false,
});
